import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const EmptyState = ({ hasFilters, isHistoryMode, onLoadHistory, onClearFilters }) => {
  const navigate = useNavigate();

  const handleBrowseRestaurants = () => {
    navigate('..', { relative: 'path' });
  };

  // 1. If we have active filters (Search or History Mode with No Results)
  if (hasFilters || (isHistoryMode && onClearFilters)) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
        <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mb-6">
          <Icon name="Search" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">
          No Orders Found
        </h3>
        <p className="text-muted-foreground mb-6 max-w-sm">
          {hasFilters 
            ? "We couldn't find any orders matching your current search. Try adjusting your search criteria."
            : "You don't have any orders in your history yet."}
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          {(hasFilters) && (
            <Button
              variant="outline"
              onClick={onClearFilters}
            >
              Clear Search
            </Button>
          )}
          <Button
            variant="default"
            onClick={handleBrowseRestaurants}
          >
            Browse Menu
          </Button>
        </div>
      </div>
    );
  }

  // 2. No orders in the last 24 hours (Recent Mode)
  if (!isHistoryMode) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
        <div className="w-20 h-20 bg-orange-50 rounded-full flex items-center justify-center mb-6">
          <Icon name="Clock" size={32} className="text-orange-500" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">
          No Recent Orders
        </h3>
        <p className="text-muted-foreground mb-8 max-w-xs mx-auto">
          You haven't placed any orders in the last 24 hours.
        </p>
        <div className="flex flex-col w-full max-w-xs gap-3">
          <Button
            variant="default"
            fullWidth
            onClick={onLoadHistory}
          >
            <Icon name="History" size={18} className="mr-2" />
            Check Order History
          </Button>
          <Button
            variant="ghost"
            fullWidth
            onClick={handleBrowseRestaurants}
            className="text-gray-500"
          >
            Order Something New
          </Button>
        </div>
      </div>
    );
  }

  // 3. Absolute default fallback
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
     <p className="text-gray-500">No orders found. <Link to='..' relative='path' className="text-primary font-bold">Browse Menu</Link></p>
    </div>
  );
};

export default EmptyState;